import { render, staticRenderFns } from "./typeform-settings.vue?vue&type=template&id=809d1e96&"
import script from "./typeform-settings.vue?vue&type=script&lang=js&"
export * from "./typeform-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports